import {AgentView} from "@src/pages/workspace/agent-view/agent-view";
import {createFileRoute, useParams} from "@tanstack/react-router";
import {TAgent} from "@zeg/instant/types";
import {useAgent} from "@zeg/instant/w/useAgents";

export const Route = createFileRoute(
  "/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/"
)({component: RouteComponent});

function RouteComponent() {
  const {workspaceSlug, agentSlug} = useParams({
    from: "/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/",
  });

  const {data, isLoading, error} = useAgent(
    workspaceSlug as string,
    agentSlug as string
  );
  const agent = data?.workspaces?.[0]?.agents?.[0];

  return (
    <AgentView
      data={agent as TAgent}
      isLoading={isLoading}
      error={error ? (error as Error) : null}
    />
  );
}
